import { render, staticRenderFns } from "./accordion.vue?vue&type=template&id=e28b2534"
import script from "./accordion.vue?vue&type=script&lang=ts"
export * from "./accordion.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports